/** Ids of the three indicator cards at the top of the Members list, in display order. */
export const MEMBER_STAT = Object.freeze({
  ACTIVE: 'active',
  PENDING: 'pending',
  ACTIVE_WITHOUT_MFA: 'activeWithoutMfa',
});

export const MEMBER_STAT_IDS = Object.freeze(Object.values(MEMBER_STAT));
